export default {
  "content": "<path d=\"M7.5 16.586l2.793-2.793 1.414 1.414-4.5 4.5a1 1 0 01-1.414 0l-4.5-4.5 1.414-1.414L5.5 16.586V5h2v11.586zM22 17h-8v-2h8v2z\" fill=\"#7B61FF\"/><path d=\"M22 12H10v-2h12v2zM22 7H10V5h12v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};